import SearchArticles from "./SearchArticles";
export default SearchArticles;
